import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@src/store";

import { initialState } from ".";

const selectSlice = (state: RootState) => state.impersonate || initialState;

export const selectIsLoadingActivateImpersonate = createSelector(
  [selectSlice],
  state => state.view.isLoadingActivateImpersonate,
);

export const selectIsLoadingDisableImpersonate = createSelector(
  [selectSlice],
  state => state.view.isLoadingDisableImpersonate,
);

export const selectHasErrorViewMode = createSelector([selectSlice], state => state.view.hasError);
